A possible response to an `ApplicationLibraryQuestion`.
